import React from "react";
import intl from "react-intl-universal";

import type {ContextMenuInterface} from "../../ContextMenuInterface";

import {GroupedActions, ContextAction} from "../utils/GroupedActions";

import {H1Icon} from "../../../../components/icons/editor/H1Icon";
import {H2Icon} from "../../../../components/icons/editor/H2Icon";
import {H3Icon} from "../../../../components/icons/editor/H3Icon";
import {BulletListIcon} from "../../../../components/icons/editor/BulletListIcon";
import {NumberListIcon} from "../../../../components/icons/editor/NumberListIcon";
import {CheckListIcon} from "../../../../components/icons/editor/CheckListIcon";
import {UploadFileIcon} from "../../../../components/icons/editor/UploadFileIcon";
import {UploadImageIcon} from "../../../../components/icons/editor/UploadImageIcon";
import {TableIcon} from "../../../../components/icons/editor/TableIcon";
import {QuoteIcon} from "../../../../components/icons/editor/QuoteIcon";
import {HorizontalLineIcon} from "../../../../components/icons/editor/HorizontalLineIcon";
import {MentionIcon} from "../../../../components/icons/editor/MentionIcon";


import {insertHeading} from '../../../../../Editor/module/commands/triggers/insertHeading';
import {uploadImageCommand} from '../../../../../Editor/module/commands/triggers/uploadImageCommand';
import {uploadFileCommand} from '../../../../../Editor/module/commands/triggers/uploadFileCommand';
import {insertList} from '../../../../../Editor/module/commands/triggers/insertList';
import {insertTable} from '../../../../../Editor/module/commands/triggers/insertTable';
import {insertBlockquote} from "../../../../../Editor/module/commands/triggers/insertBlockquote";
import {insertMentionTrigger} from "../../../../../Editor/module/commands/triggers/insertMentionTrigger";
import {insertHorizontalLine} from "../../../../../Editor/module/commands/triggers/insertHorizontalLine";


export interface PlusIconTooltipSelfProps {
    getPos: () => number | undefined,
}

export interface PlusToolbarProps extends ContextMenuInterface, PlusIconTooltipSelfProps {
}

const headingActionsGroup: ContextAction[] = [
    {
        id: 'H1',
        Icon: H1Icon,
        getTitle: () => intl.get('trigger-actions.large_heading').d('Large heading'),
        action: insertHeading(1),
    },
    {
        id: 'H2',
        Icon: H2Icon,
        getTitle: () => intl.get('trigger-actions.medium_heading').d('Medium heading'),
        action: insertHeading(2),
    },
    {
        id: 'H3',
        Icon: H3Icon,
        getTitle: () => intl.get('trigger-actions.small_heading').d('Small heading'),
        action: insertHeading(3),
    },
];

const listActionsGroup: ContextAction[] = [
    {
        id: 'BulletList',
        Icon: BulletListIcon,
        getTitle: () => intl.get('trigger-actions.bullet_list').d('Bulleted list'),
        action: insertList('bullet'),
    },
    {
        id: 'NumberList',
        Icon: NumberListIcon,
        getTitle: () => intl.get('trigger-actions.number_list').d('Numbered list'),
        action: insertList('ordered'),
    },
/*    {
        id: 'CheckList',
        Icon: CheckListIcon,
        getTitle: () => intl.get('trigger-actions.task_list').d('Task list'),
        action: insertList('checklist'),
    },*/
];

const thirdActionsGroup: ContextAction[] = [
    {
        id: 'UploadFile',
        Icon: UploadFileIcon,
        getTitle: () => intl.get('trigger-actions.upload_file').d('Upload file'),
        action: uploadFileCommand,
    },
    {
        id: 'UploadImage',
        Icon: UploadImageIcon,
        getTitle: () => intl.get('trigger-actions.upload_image').d('Upload image'),
        action: uploadImageCommand,
    },
    {
        id: 'Table',
        Icon: TableIcon,
        getTitle: () => intl.get('trigger-actions.table').d('Table'),
        action: insertTable,
    },
];

const otherActionsGroup: ContextAction[] = [
    /*   {
          id: 'AppsAndIntegrations',
          Icon: AppsAndIntegrationsIcon,
          getTitle: () => intl.get('trigger-actions.apps_and_integrations').d('Apps & Integration'),
          action: insertHeading(3),
      },
      {
          id: 'CodeBlock',
          Icon: CodeBlockIcon,
          getTitle: () => intl.get('trigger-actions.code_block').d('Code block'),
          action: insertHeading(3),
      },*/
    {
        id: 'Quote',
        Icon: QuoteIcon,
        getTitle: () => intl.get('trigger-actions.quote').d('Quote'),
        action: insertBlockquote,
    },
    {
        id: 'HorizontalLine',
        Icon: HorizontalLineIcon,
        getTitle: () => intl.get('trigger-actions.horizontal_line').d('Horizontal line'),
        action: insertHorizontalLine,
    },
    {
        id: 'Mention',
        Icon: MentionIcon,
        getTitle: () => intl.get('trigger-actions.mention').d('Mention'),
        action: insertMentionTrigger,
        preserveContextMenu: true,
    },

];

const groupedActions: ContextAction[][] = [
    headingActionsGroup,
    listActionsGroup,
    thirdActionsGroup,
    otherActionsGroup,
]


export const PlusToolbar = ({handleClose, isDark, ...specificParams}: PlusToolbarProps) => {
    return <GroupedActions
        isDark={isDark}
        handleClose={handleClose}
        actionGroups={groupedActions}
        additionalParams={specificParams}
    />
}
